export default interface DownloadState {
  [downloadId: string]: {    
    downloadStarted?: boolean;
    downloadSucceed?: boolean;
    downloadFailed?: boolean;
  }
};

export const initialDownloadState: DownloadState = {};